import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _get from "lodash/get";
import {connect} from 'react-redux';
import {accountModifyRecord} from '../../actions/account';
import EditContactEmail from './EditContactEmailForm';

/*eslint-disable react/no-unused-prop-types */

class ContactEmailPref extends Component {

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(values) {
    let accountId = _get(this.props.auth, 'currentLoggedInUser.accountId');
    let data = {
      method: 'put',
      body: {
        primaryEmail: {
          emailAddress: _get(values, 'contactEmail'),
          type: _get(this.props.auth, 'currentLoggedInUser.primaryEmail.type', 'PERSONAL'),
        }
      }
    }
    return Promise.resolve(this.props.dispatch(accountModifyRecord(data, null, accountId)))
        .then(() => {
          //return this.props.dispatch(getLoginRefresh(accountId));
          return;
        });
  }

  render() {
    return (
        <div className="ma-modal">
          <EditContactEmail propConEmail={this.props.propConEmail} propConAlertEmail={this.props.propConAlertEmail} onSubmit={this.handleSubmit} />
        </div>
    );
  }

}


ContactEmailPref.propTypes = {
  auth: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  propConEmail: PropTypes.string,
  propConAlertEmail: PropTypes.string
};

function mapStateToProps(state) {
  const { form, auth } = state;
  if (form || auth) {
    return { form: form.editcontactemail, auth };
  }
}

export default connect(mapStateToProps)(ContactEmailPref);

/*eslint-enable react/no-unused-prop-types */



// WEBPACK FOOTER //
// ./src/containers/monitoring/ContactEmailPref.js